import React, { useState, useEffect }from 'react';
import { Toolbar, Grid, Button, Card, CardContent,TableBody,
  TableRow,  Table, makeStyles, TableHead, TextField,
} from "@material-ui/core";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import CustomInput from "components/custom/CustomInput";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import {fetchDropDownData,fetchOutBondListing} from "shared/api/purple/outbondPayment";
import ViewData from './viewData';
import CustomSelect from "components/custom/CustomSelect";
import ActionModal1 from './actionModal'
import ReEnqireModal from './reEnqireModal'
import Pagination from "@material-ui/lab/Pagination";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Tooltip } from '@material-ui/core';
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import CodeIcon from "@material-ui/icons/Code";
import ResponseMsg from './ResponseMsg';
import './auto.css'
import {DatePicker} from "@material-ui/pickers";
import KisshtButton from "components/ui/KisshtButton";
import moment from "moment";
import {toastSuccess, toastError,readableFormatDate,DateHandle,filterValidation } from "shared/utils";
import { PERMISSIONS, ROUTE_NAME } from 'shared/constants';
import PermissionMenu from '../../../components/ui/PermissionMenu';
import {getExportToExcelList } from "shared/api";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 650,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }));
  const iconStyle={
    background:"rgb(198 185 221)",
    opacity:"1",
    padding:"4px",
    borderRadius:"50%",
    height:"30px",
    width:"30px",
    verticalAlign:"middle",
    margin:"0px"  
}

const buttonStyle={
  background:"green",
  opacity:"1",
  padding:"2px",
  width:"40px",
  verticalAlign:"middle",
  margin:"0px",
  color:"#fff",
  textAlign:"center"

}



export const OutbondPayment = (props) => {
    const classes = useStyles();
    const { updateQueryParams } = props;
    const [search, setSearch] = useState("");
    const [openConfigModal, setopenConfigModal] = useState(false);
    const [responseModal, setResponseModel] = useState(false);
    const[propsData,setPropsData] = useState('');
    const[actionStatus] = useState('');
    const[paymentType,setPaymentType] = useState('');
    const[paymentMode,setPaymentMode] = useState('');
    const[status,setStatus] = useState('');
    const[fromDate,setFromDate] = useState(null);
    const[toDate,setToDate] = useState(null);
    const[searchKey,setSearchKey] = useState('');
    const[apiDropDownData,setApiDropDownData] = useState('');
    const [outbondReEnqireModal, setOutbondReEnqireModal] = useState(false)
    const [reenqireData ,setReEnqireData] = useState()
    const [editStatusData, setEditStatusData] = useState('')
    const [openActionModal, setOpenActionModal] = useState(false);
    const [bankId, setBankId] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [outBondListData,setOutBondListData] =useState('')
    const [outBondPageCount,setOutBondPageCount] =useState(0)
    const [count, setCount] = useState();
    const [reload, setreload] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    let text =JSON.stringify(new Date())
    const myArray = text.split(" ");
    const dateFormat = myArray[0].split("T")
   let newdata= dateFormat[0].replace(/["]/g ,"")


    useEffect(() => {
      paramAPIList();
      fetchOutBondListApi(0)
      // eslint-disable-next-line
      }, [reload]);

//listing api change
const fetchOutBondListApi = async (page) => {
  const listingData = {
    "offset": page,
    "limit": 20,
    [searchKey]:search, 
    "status":status,
    "payment_type":paymentType,
    "payment_mode":paymentMode, 
    "from_date":fromDate, 
    "to_date":toDate
  }
  Object.keys(listingData).forEach(key =>{
    if(listingData[key] === "" || listingData[key] === null){
      delete listingData[key]
    }
  })
  await updateQueryParams({ search });
  fetchOutBondListing(listingData)
    .then((res) => {
      
      if (res?.data?.list?.length > 0) {
        setOutBondListData(res?.data?.list);
        setCount(res?.data?.count);
        var quotient = Math.ceil(res?.data?.count/20)
        setOutBondPageCount(quotient);
      } else {
        setOutBondListData([]);
      }
    })
    .catch((error) => {
      setOutBondListData([]);
    
    });
};
// paramAPIList
const paramAPIList = async ()=>{
  
    await updateQueryParams({ search });
    
    await fetchDropDownData()
      .then((res) => {
        
        if (res.hasOwnProperty("success") && res.success) {
          const { data } = res;
          if (data) {
            setApiDropDownData(data);
          } else {
            setApiDropDownData([]);
          }
        }
      })
      .catch((error) => {
        
        return null
      });
}
const outBoundExportHandle = async()=>{
  const payload = {
      "module_name": "outbound_payments",
      "checkbox_ids": "",
      [searchKey]:search, 
      "status":status,
      "payment_type":paymentType,
      "payment_mode":paymentMode, 
      "from_date":fromDate, 
      "to_date":toDate 
  }
  Object.keys(payload).forEach(key => {
    if (payload[key] === '' || payload[key] === null) {
      delete payload[key];
    }
  });
  getExportToExcelList(payload)
  .then((res) => {
    if (res.hasOwnProperty("success") && res.success) {
      if(res){
        toastSuccess(res.message);
      }else{
        toastError(res.message);
      }
    }
  })
  .catch((error) => {
    toastError(error.message);

  });
}
let mainData = apiDropDownData?.outboundPaymentsDetailsSearchOption;
let paymentTypeData = mainData?.payment_type;
let paymentModeData = mainData?.payment_mode;
let statusData = mainData?.status;
let searchKeyData = mainData?.search_parameters;

 
let viewResponseData ;
  const viewResponseHandle = (BankDetails) =>{
    let newdata = BankDetails;
    viewResponseData = newdata;
    setopenConfigModal(true)
    setPropsData(viewResponseData);
  }

  const handleModalClosed = () => {
    setopenConfigModal(!openConfigModal)
  };
  const handleModal = (data) => {
    setResponseModel(!responseModal)
    setBankId(data)

  };
 
  const handleReEnqireModal = (item) => {
    setOutbondReEnqireModal(!outbondReEnqireModal)
    let data = item;
    setReEnqireData(data)
  };

  const handleReEnqireModalClosed = (item) => {
    setOutbondReEnqireModal(!outbondReEnqireModal)
  };
  const handleSearch = () => {
    fetchOutBondListApi(0);
    setCurrentPage(1)
  };


  const statusHandleEvent = (e, item) => {
    let editData = {
      "outbound_id": item.id,
      "change_to": e.target.value,
      "response_key": item.response_key,
      "cms_ref_number": item.cms_reference_number,
      "source_reference_number": item.source_reference_number
    }
    if((e.target.value === "SUCCESS") || (e.target.value === "FAILED")){
        var answer = window.confirm("Are you Sure want to change status?");
        if (answer) {
          setOpenActionModal(true)
          setEditStatusData(editData)
        } else {
          setOpenActionModal(false)
          setEditStatusData('')
        }
    }
  }

  
  const handleStatusChangeModalClose = () => {
    setOpenActionModal(false)
    fetchOutBondListApi(0)
  }
  const handleSelect =  async (e) =>{
    e.persist();
    let item = e.target.value;
    if(!item){
      setSearchKey("");
      setSearch("");
      setCurrentPage(1) 
      setreload(!reload); 
    }
    else{
      setSearchKey(item)
      setSearch("");
    }
  }

  const OnHandleSearch = (e) => {    
    const validation_msg = filterValidation(searchKey,e.target.value)
    setSearch(e.target.value)
    setErrorMessage(validation_msg)
  }
    const refreshHandler =  () => {
        setPaymentType("");
        setPaymentMode("");
        setStatus("");
        setSearchKey("");
        setSearch("");
        setFromDate(null);
        setToDate(null);
        setCurrentPage(1)
        setreload(!reload); 
    };
    const formDateHandle =(e) =>{
      const formated_date =  DateHandle(e);
      setFromDate(formated_date)
    }
    const toDateHandle =(e) =>{
      const formated_date =  DateHandle(e);
      setToDate(formated_date)
    }
  
      const onPageClickChange =  (event, value) => {
         setCurrentPage(value); 
         fetchOutBondListApi(value-1) 
      }


    return (
        <div>
            <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader closeSideDrawer={() => {}} />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center" className="crum_padding">
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item lg={3} md={3} sm={4} xs={8}>
                  <BreadcrumbsHeader text="Outbond Payment Details " />
                </Grid>

              <Grid item lg={9} md={9} sm={12} xs={12} className='top_spacing_btn'>
              <Grid container spacing={1} justifyContent="flex-end">
                <Grid item>
                  <Tooltip title="Total Records">
                  <KisshtButton
                      size="small"
                      onClick={() => outBoundExportHandle()}
                      route={ROUTE_NAME.outbound_payment}
                      permission={PERMISSIONS.outbound_payment.export_excel}
                      endIcon={<CloudUploadIcon />}
                      disabled={(fromDate != null && toDate === null) || (fromDate === null && toDate != null)  || (searchKey && search ==="") ? true : false}
                    >Export To Excel
                  </KisshtButton>
                  </Tooltip>
                </Grid>
              </Grid>
              </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} className="crum_innerPadding">
              <Grid container spacing={1} alignItems="center">
                    <Grid item className=''>
                      <CustomSelect
                        onChange={(e) => setPaymentType(e.target.value)}
                        multiple={false}
                        nulloption="Payment Type"
                        value={paymentType}
                        options={{
                            PENNY_DROP:paymentTypeData?.PENNY_DROP,
                            SETTLEMENT:paymentTypeData?.SETTLEMENT,                    
                        }}
                        className="common_global_filter"
                      />
                    </Grid>
                    <Grid item className=''>
                      <CustomSelect
                        onChange={(e) => setPaymentMode(e.target.value)}
                        multiple={false}
                        nulloption="Payment Mode"
                        value={paymentMode}
                        options={{
                          RTGS: paymentModeData?.RTGS,
                          IMPS: paymentModeData?.IMPS,
                          NEFT: paymentModeData?.NEFT,
                          UPI: paymentModeData?.UPI,
                          IFT: paymentModeData?.IFT,
                        }}
                        className="common_global_filter"
                      />
                    </Grid>
                    <Grid item className="">
                      <CustomSelect
                        onChange={(e) => setStatus(e.target.value)}
                        multiple={false}
                        nulloption="Select Status"
                        value={status}
                        options={{
                          PENDING:statusData?.PENDING,
                          SUCCESS:statusData?.SUCCESS,
                          FAILED: statusData?.FAILED,
                        }}
                        className="common_global_filter"
                      />
                    </Grid>
                  <Grid item className=''>
                      <CustomSelect
                         onChange={handleSelect}
                         multiple={false}
                        nulloption="Select"
                        value={searchKey}
                        options={searchKeyData}
                        className="common_global_filter"
                    />
                    </Grid>
                    <Grid>
                      <Grid item>
                        <CustomInput
                          placeholder="Search"
                          // maxwidth="200px"
                          onChange={(e) => OnHandleSearch(e)}
                          value={search}
                          className="common_custom_input"
                        />
                      </Grid>
                      <Grid>
                          {search ? <span style={{"color":"red",fontSize:'13px',position:'absolute'}}>{errorMessage}</span>: ""}
                      </Grid>
                    </Grid>
                  <Grid item xs={12}>
                  <Grid container spacing={1} alignItems="center">
                  <Grid item className="">
                    <label className="from-to-date-label">From Date</label>
                      <DatePicker 
                          helperText={false}
                          className="date_style"
                          disableFuture
                          format="yyyy-MM-dd"
                          onChange={(e) => formDateHandle(e)}
                          value={fromDate}
                          placeholder={"Select From Date"}
                          renderInput={props => <TextField {...props} style={{color:'#e2e8f0'}}/>}
                      />
                 </Grid>
                 <Grid>
                    <label className="from-to-date-label">To Date</label>
                      <DatePicker 
                          disableFuture
                          className="date_style"
                          format="yyyy-MM-dd"
                          helperText={false}
                          onChange={(e) => fromDate === "" ? alert("first pick from date"): toDateHandle(e)  }
                          value={toDate}
                          placeholder={"Select To Date"}
                          renderInput={props => <TextField {...props} style={{color:'#e2e8f0'}}/>}
                      />
                  </Grid>
                   <Grid item>
                      <Button
                        variant="contained"
                        className="shadow-none common_kissht_btn"
                        color="primary"
                        onClick={() => handleSearch()}
                        disabled={(paymentType?.length > 0 || paymentMode?.length > 0 || (search?.length > 0 &&  searchKey?.length > 0) || (fromDate && toDate)|| status?.length > 0) && !errorMessage ? false : true}
                      >
                        Search
                      </Button>
                   </Grid>
                  <Grid item>
                    <Button onClick={refreshHandler} size="small" color="primary">
                      Reset
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          </Grid> 
        </Grid>
        </Toolbar> 
      </Header>
      <div className='padding_top_auto_outbond _outbond_extra_padding'></div>
      {outBondListData.length > 0 ?
      <Card style={{ boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`}} className={classes.card}>
            <CardContent style={{ height: "50px" }}>
              <Grid container className="grid-vertical-align-center">
                <Grid item xs={12}>
                  <p
                    className="text-xs"
                    style={{
                      color: Colors["lightPurple"],
                      float: "right"
                    }}
                  >
                    {
                        count < 10 ? 
                    null:
                    <Pagination color="primary"  count={outBondPageCount}  page={currentPage} onChange={onPageClickChange} /> 
                     }
                  </p>
                </Grid>
              </Grid>
            </CardContent>
        <CardContent style={{overflowX:'scroll'}} className="p-1 _commontable_mobile">
        <Table className={classes.table}>
                          <TableHead>
                            <TableRow>                
                            <TableBodyCell className="new_style">
                            Outbound Reference Number	
                            </TableBodyCell>
                            <TableBodyCell className="new_style">
                            Source Reference Number
                            /Transaction_reference_number 	
                            </TableBodyCell>
                            <TableBodyCell className="new_style">
                            Source Type	
                            </TableBodyCell>
                            <TableBodyCell className="new_style">
                            Bank Name	
                            </TableBodyCell>
                           <TableBodyCell className="new_style">
                           Payment Mode	
                            </TableBodyCell>
                            <TableBodyCell className="new_style">
                            Amount	
                            </TableBodyCell>
                            <TableBodyCell className="new_style">
                            	Response_key / Cms_reference_number	
                            </TableBodyCell>
                            <TableBodyCell className="new_style">
                            Status	
                            </TableBodyCell>
                            </TableRow>
                          </TableHead>
                          {outBondListData.map((item) =>{
                            let BankDetails = {
                              "bank_api_response":item.bank_api_response,
                            }
                            if(outBondListData?.length < 1){
                              return <div className='global_center'> No records found.</div>
                          }
                           return<TableBody>
                                <TableRow>
                                    <TableBodyCell style={{color:"#355e3b",fontWeight:"bold"}}>{item.outbound_reference_number} </TableBodyCell>
                                    <TableBodyCell className="new_style">{item.source_reference_number} / {item.transaction_reference_number} </TableBodyCell>
                                    <TableBodyCell className="new_style"> {item.source_type} </TableBodyCell>
                                    <TableBodyCell className="new_style"> {item.bank_name} </TableBodyCell>
                                    <TableBodyCell className="new_style">{item.payment_mode}</TableBodyCell>
                                    <TableBodyCell >{item.amount}</TableBodyCell>
                                    <TableBodyCell>{item.response_key} / {item.cms_reference_number}</TableBodyCell>
                                    <TableBodyCell> <BootstrapBadge text={item.status}></BootstrapBadge> </TableBodyCell>
                                    <TableRow style={{height: "1px", boxShadow: "initial"}}></TableRow>

                                    </TableRow>
                                        <TableRow>
                                    
                                          <TableBodyCell className="date_column_style">
                                            <Tooltip arrow title="created_at" placement="bottom">
                                            <DateRangeOutlinedIcon  style={iconStyle}/>
                                            </Tooltip>
                                            <Grid item className="style_date">{item.created_at} </Grid>
                                          </TableBodyCell>

                                          <TableBodyCell > 
                                            {item.response_code ?
                                          <Tooltip arrow title="Response Code" placement="bottom">
                                          <CodeIcon style={iconStyle} />
                                          </Tooltip>:"--"}
                                          {item.response_code}
                                          </TableBodyCell>

                                          <TableBodyCell colspan="3">
                                          <KisshtButton
                                              size="small"
                                              startIcon={<VisibilityIcon />}
                                              variant="outlined"
                                              onClick={() => viewResponseHandle(BankDetails)}
                                              route={ROUTE_NAME.outbound_payment}
                                              permission={PERMISSIONS.outbound_payment.view_response}
                                              className="common_kissht_btn"
                                              >View Response
                                            </KisshtButton>
                                        
                                            <KisshtButton style={{marginLeft:'6px'}}
                                                size="small"
                                                startIcon={<VisibilityIcon />}
                                                variant="outlined"
                                                onClick={() => handleModal(item.user_bank_details_id)}
                                                route={ROUTE_NAME.outbound_payment}
                                                permission={PERMISSIONS.outbound_payment.view_bank}
                                                className="common_kissht_btn"
                                                >View Bank
                                            </KisshtButton>
                                            
                                          </TableBodyCell>
                                        
                                          <TableBodyCell>
                                          <Tooltip title="Reconciliation Status">
                                            <p style={buttonStyle}>{item.reconciliation_status}</p>
                                            </Tooltip>
                                              
                                                {/* <Tooltip title="Reconciliation Status">
                                                <KisshtButton
                                                  style={{backgroundColor:"green",color:"#fff",padding:'0px'}}
                                                >{item.reconciliation_status}</KisshtButton>
                                                </Tooltip> */}
                                          </TableBodyCell>

                                          <TableBodyCell >
                                            {item.status == "SUCCESS" ? "- / -" :
                                            <KisshtButton
                                            variant="outlinedPrimary"
                                            className={`${classes.button} common_kissht_btn`}
                                            size="small"
                                            onClick={() => handleReEnqireModal(item)}
                                            route={ROUTE_NAME.outbound_payment}
                                            permission={PERMISSIONS.outbound_payment.re_enquire}
                                              >
                                                Re Enquire
                                            </KisshtButton>}
                                          </TableBodyCell>

                                          <TableBodyCell>
                                          {item.reconciliation_status == "YES" ? "" :
                                          <PermissionMenu
                                          style={{minWidth:"135px"}}
                                          onChange={(e) => statusHandleEvent(e,item)}
                                          multiple={false}
                                          nulloption="Select status"
                                          value={actionStatus}
                                          route={ROUTE_NAME.outbound_payment}
                                          permission={PERMISSIONS.outbound_payment.change_status}
                                          options={{
                                              SUCCESS: "SUCCESS",
                                              FAILED: "FAILED",
                                          }}
                                      />}
                                          </TableBodyCell>
                                      
                                    </TableRow>
                                
                              </TableBody>
                       } )}  
            </Table>
            {/* <div  style={{float:"right",padding:'10px'}}>
              {
                count < 10 ? 
                    null:
                    <Pagination color="primary"  count={outBondPageCount}  page={currentPage} onChange={onPageClickChange} /> 
                     }
            </div> */}
        </CardContent>
        <CardContent style={{ height: "50px",paddingBottom:'70px'}}>
              <Grid container className="grid-vertical-align-center">
              <div  style={{float:"right",padding:'10px'}}>
              {
                count < 10 ? 
                    null:
                    <Pagination color="primary"  count={outBondPageCount}  page={currentPage} onChange={onPageClickChange} /> 
                     }
            </div>
              </Grid>
            </CardContent>
      </Card> : <div className='global_center'> No records found.</div>}
      
          <ViewData
            visible={openConfigModal}
            handleDialogClose={() => handleModalClosed()}
            data={propsData}
          />
          {responseModal ?
          <ResponseMsg
            visible={responseModal}
            handleDialogClose={() => handleModal()}
            data={bankId}
          />:""}
        <ActionModal1
            visible={openActionModal}
            handleDialogClose={() => handleStatusChangeModalClose()}
            data={editStatusData}
          />
            {outbondReEnqireModal ? 
          <ReEnqireModal
          visible={outbondReEnqireModal}
          handleDialogClose={() => handleReEnqireModalClosed()}
           data={reenqireData}
          /> :""}
          
        </div>
    )
}
export default OutbondPayment;